import { useState } from "react";
import { CONTACT } from "../../constants";
import "./Contact.css";

const INTEREST_OPTIONS = [
  "Purchase a 2-Bedroom Unit",
  "Purchase a 3-Bedroom Unit",
  "Investment Opportunity",
  "General Enquiry",
];

const EMPTY_FORM = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  interest: INTEREST_OPTIONS[0],
  message: "",
};

export default function Contact() {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [status, setStatus] = useState("idle"); // 'idle' | 'loading' | 'success' | 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (status === "loading") return;

    const { firstName, lastName, email, phone, interest, message } = formData;

    if (!firstName || !email || !message) {
      setStatus("error");
      return;
    }

    setStatus("loading");

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/contact-us`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: `${firstName} ${lastName}`.trim(),
          email,
          phone,
          interest,
          message,
        }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setStatus("success");
        setFormData(EMPTY_FORM);
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  const handleReset = () => setStatus("idle");

  return (
    <section id="contact" className="contact-section">
      <div className="contact-section__left">
        <p className="eyebrow">Contact Us</p>
        <h2 className="section-title">
          Enquire about
          <br />
          <em>a development.</em>
        </h2>
        <p className="contact-section__sub">
          Reach out to our development team directly. Whether you're purchasing
          a unit or exploring investment opportunities, we're ready to assist.
        </p>

        <div className="contact-section__items">
          <div className="contact-item contact-item--phones">
            <div className="contact-item__icon">📞</div>
            <div>
              <span className="contact-item__label">Call Us</span>
              <a
                href={CONTACT.phoneHref}
                className="contact-item__value contact-item__value--tel"
              >
                {CONTACT.phone}
              </a>
            </div>
          </div>

          <a href={CONTACT.emailHref} className="contact-item">
            <div className="contact-item__icon">✉️</div>
            <div>
              <span className="contact-item__label">Email Us</span>
              <span className="contact-item__value">{CONTACT.email}</span>
            </div>
          </a>

          <div className="contact-item">
            <div className="contact-item__icon">📍</div>
            <div>
              <span className="contact-item__label">Visit Us</span>
              <span className="contact-item__value contact-item__value--address">
                {CONTACT.address}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-section__right">
        {status === "success" ? (
          <div className="contact-success">
            <div className="contact-success__icon">✓</div>
            <h3 className="contact-success__title">Enquiry Sent</h3>
            <p className="contact-success__body">
              We've received your message and a confirmation has been sent to
              your email. Our team will be in touch within{" "}
              <strong>24–48 hours</strong>.
            </p>
            <button className="contact-success__reset" onClick={handleReset}>
              Send Another Enquiry
            </button>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit} noValidate>
            {status === "error" && (
              <p className="contact-form__error">
                Please fill in your name, email, and message — or your message
                could not be sent. Please try again.
              </p>
            )}

            <div className="contact-form__row">
              <div className="field">
                <label htmlFor="firstName">First Name</label>
                <input
                  id="firstName"
                  name="firstName"
                  type="text"
                  placeholder="Adaeze"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="field">
                <label htmlFor="lastName">Last Name</label>
                <input
                  id="lastName"
                  name="lastName"
                  type="text"
                  placeholder="Okonkwo"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="hello@example.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="field">
              <label htmlFor="phone">Phone Number</label>
              <input
                id="phone"
                name="phone"
                type="tel"
                placeholder="+234 800 000 0000"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="field">
              <label htmlFor="interest">I am interested in</label>
              <select
                id="interest"
                name="interest"
                value={formData.interest}
                onChange={handleChange}
              >
                {INTEREST_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tell us about what you're looking for…"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button
              className="contact-form__submit"
              type="submit"
              disabled={status === "loading"}
            >
              {status === "loading" ? "Sending…" : "Send Enquiry →"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
